<template>
  <div>
    <div style="background-color:#EBE9EA" class="first-block">
      <div class="container-block">
        <div class="search-block">
          <div class="left-block">
            <h3>Search for veterinary medications</h3>
          </div>
          <div class="right-block">
            <form class="search-wrap" @submit.prevent="refreshSearch">
              <input v-model="query" type="text" name="q" placeholder="Search medications" >
              <button type="submit" class="button icon-search"/>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="top-indent">
      <div class="container-block">
        <h4 class="mobile-title mobile">Search Results{{ resultsCounter }}</h4>
        <div class="content-wrap column-t">
          <div class="left-sidebar">
            <h3 class="title desktop">Filter by</h3>
            <div class="mobile-head mobile">
              <div class="filter-btn">
                <div class="text">Filter</div>
                <div class="icon icon-filter"/>
              </div>
              <div class="input-wrap">
                <div class="select-wrap">
                  <select v-model="sort" placeholder="Sort" class="select">
                    <option value="asc">A&rarr;Z</option>
                    <option value="desc">Z&rarr;A</option>
                  </select>
                  <span v-if="!sort" class="placeholder">A&rarr;Z</span>
                </div>
              </div>
            </div>
            <button class="btn" @click="clearFilters">Clear search results & Filters</button>
            <div class="checkbox-wrap gray">
              <div v-for="(type, idx) in productTypes" :key="idx" class="checkbox">
                <input v-model="types" :value="type.slug" type="checkbox" name="types" >
                <div class="icon"/>
                <div class="label">{{ type.title }}</div>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="search-result-list">
              <div class="head desktop">
                <div class="left-block">
                  <h3 class="title">Search Results{{ resultsCounter }}</h3>
                </div>
                <div class="right-block">
                  <div class="select-wrap">
                    <select v-model="sort" placeholder="Sort" class="select">
                      <option value="asc">A&rarr;Z</option>
                      <option value="desc">Z&rarr;A</option>
                    </select>
                    <span v-if="!sort" class="placeholder">A&rarr;Z</span>
                  </div>
                </div>
              </div>
              <div class="body">
                <a
                  v-for="(item, idx) in paginatedItems"
                  :href="'/products/item/' + item.slug"
                  :key="idx"
                  class="item"
                >
                  <div class="text">{{ item.title }}</div>
                  <div class="icon icon-arrow-right"/>
                </a>
              </div>
              <paginate
                v-if="pagesCount > 1"
                v-model="page"
                :page-count="pagesCount"
                :page-range="3"
                :margin-pages="2"
                :no-li-surround="true"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-link-class="'item'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import queryString from 'query-string'

export default {
  name: 'SearchBlock',
  components: { Paginate },
  props: ['searchParams', 'productTypes', 'searchResults'],
  data: () => {
    return {
      query: '',
      types: [],
      sort: 'asc',
      page: 1,
      items: []
    }
  },
  computed: {
    resultsCounter () {
      let resultString = ''
      let items = this.resultItems.slice() || []

      if (items.length !== 0) {
        if (items.length <= 10) {
          resultString = ` (1-${items.length} of ${items.length})`
        } else {
          let firstRange = (this.page - 1) * 10 + 1
          let lastRange =
            (this.page * 10 <= items.length && this.page * 10) || items.length
          resultString = ` (${firstRange}-${lastRange} of ${items.length})`
        }
      }

      return resultString
    },
    resultItems () {
      let app = this
      let items = (this.items && this.items.slice()) || []

      if (app.sort === 'desc') {
        items = items.sort((a, b) => {
          let aName = a.title.toUpperCase()
          let bName = b.title.toUpperCase()
          if (aName > bName) {
            return -1
          }

          if (bName < aName) {
            return 1
          }

          return 0
        })
      }

      if (app.types.length !== 0) {
        items = items.filter(item => {
          return (
            item.catalogue_types
              .map(subItem => subItem.type_slug)
              .filter(value => app.types.includes(value)).length !== 0
          )
        })
      }

      return items
    },
    paginatedItems () {
      let firstRange = (this.page - 1) * 10
      let lastRange =
        (this.page * 10 <= this.resultItems.length && this.page * 10) ||
        this.resultItems.length

      return this.resultItems.slice(firstRange, lastRange)
    },
    pagesCount () {
      return Math.ceil(this.resultItems.length / 10)
    }
  },
  watch: {
    resultItems: function () {
      if (this.page > this.pagesCount) {
        this.page = this.pagesCount
      }
    },
    sort: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.updateUrl('sort', newValue)
      }
    },
    types: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.updateUrl('types', newValue)
      }
    },
    page: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.updateUrl('page', newValue)
      }
    }
  },
  mounted () {
    this.$root.ajaxSearch = true
    this.query = this.searchParams.query
    this.page = this.searchParams.page
    this.types = this.searchParams.types
    this.items = this.searchResults
  },
  methods: {
    refreshSearch () {
      axios
        .post('/api/public/search', {
          query: this.query,
          sort: this.sort
        })
        .then(response => {
          if (response && response.data && response.data.result === 'ok') {
            this.page = 1
            this.items = response.data.items
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateUrl (prop, value) {
      let newQueryString = queryString.parse(location.search)
      let options = { arrayFormat: 'comma' }
      newQueryString[prop] = value
      history.pushState(
        {},
        null,
        '/search?' + queryString.stringify(newQueryString, options)
      )
    },
    clearFilters () {
      this.query = ''
      this.types = []
      this.sort = 'asc'
      this.page = 1
      this.refreshSearch()
    }
  }
}
</script>

<style>
</style>
